import { TourState } from 'editor/src/store/editorModules/tour/types';
import { RootState } from 'editor/src/store/index';

const getActiveIntroTourStep = (state: RootState): TourState['activeIntroTourStep'] => {
  return state.editorModules.tour.activeIntroTourStep;
};

export default getActiveIntroTourStep;
